import { render, staticRenderFns } from "./PersonConjugation.vue?vue&type=template&id=c922fd46&"
import script from "./PersonConjugation.vue?vue&type=script&lang=js&"
export * from "./PersonConjugation.vue?vue&type=script&lang=js&"
import style0 from "./PersonConjugation.vue?vue&type=style&index=0&id=c922fd46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports